import { ClassNameOnlyProps } from 'module/types/common';
import { Button, type ButtonProps } from '@rocketlane/ui';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface Action {
  title: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  variant?: ButtonProps['variant'];
  dataCy?: string;
}

interface Props extends ClassNameOnlyProps {
  primary: Action;
  secondary?: Action;
  other?: Action[];
  reverse?: boolean;
}

const ActionButton: FC<
  React.PropsWithChildren<Action & ClassNameOnlyProps>
> = ({ className, title, onClick, disabled, variant, danger, dataCy }) => (
  <Button
    className={className}
    size="small"
    type="button"
    variant={danger ? 'dangerSecondary' : (variant ?? 'ghost')}
    onClick={onClick}
    disabled={disabled}
    data-cy={dataCy ?? `action-panel.footer.btn.${title}`}
  >
    {title}
  </Button>
);

const Wrapper = styled.div<{ $reverse: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  flex-direction: ${({ $reverse }) => ($reverse ? 'row-reverse' : 'row')};
`;

const ActionFooterComponent: FC<React.PropsWithChildren<Props>> = ({
  className,
  primary,
  secondary,
  other = [],
  reverse,
}) => (
  <Wrapper
    className={className}
    $reverse={!!reverse}
    data-cy="action-panel.footer.wrapper"
  >
    <ActionButton dataCy="action-panel.footer.primary-btn" {...primary} />
    {secondary == null ? null : (
      <ActionButton dataCy="action-panel.footer.secondary-btn" {...secondary} />
    )}
    {other.map((action, idx) => (
      <ActionButton key={idx} {...action} />
    ))}
  </Wrapper>
);

export const ActionFooter = styled(ActionFooterComponent)``;
